import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import 'lib-flexible/flexible.js'
import "./assets/css/reset.scss";
import "./assets/css/common.scss";

// 1. 引入你需要的组件
import { Button, List, Loading, Lazyload, Image as VanImage, PullRefresh,
Icon, Tab, Tabs, Popup, CellGroup, Form, Field, Cascader, Toast, Dialog, 
Stepper, Swipe, SwipeItem} from 'vant';

// 2. 引入组件样式
import 'vant/lib/index.css';

const app = createApp(App)
app.use(Button).use(List).use(VanImage).use(Lazyload).use(Loading).use(PullRefresh).use(Icon).
use(Tab).use(Tabs).use(Popup).use(CellGroup).use(Form).use(Field).use(Cascader).use(Stepper).
use(Toast).use(Dialog).use(Swipe).use(SwipeItem).use(store).use(router).mount('#app')